var _path, _circle, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLogInIcon = function SvgLogInIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 37,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.21h30v15.122a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V16.211Z",
    fill: "#0D66FC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.999,
    cy: 26.273,
    r: 4.015,
    fill: "#F8CFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.962 5.324h10.545-10.545Zm0 0H3.938h11.024ZM6.258 9.281h2.22-2.22Zm0 0h-2.32 2.32ZM23.287 9.281h2.22-2.22Zm0 0h-2.321 2.32ZM14.896 1.367h7.77-7.77Zm0 0H6.773h8.123ZM6.258 13.238h2.22-2.22Zm0 0h-2.32 2.32Z",
    stroke: "#2576FF",
    strokeWidth: 1.499,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgLogInIcon;